import React from 'react';
import { Briefcase, Users, Home, Shield, Scale, FileText, Building, Award, Gavel, File } from 'lucide-react';
import { Card } from '../components/ui/card';
import { practiceAreas } from '../mockData';

const iconMap = {
  Briefcase: Briefcase,
  Users: Users,
  Home: Home,
  Shield: Shield,
  Scale: Scale,
  FileText: FileText
};

const PracticeAreas = () => {
  return (
    <div className="min-h-screen bg-[#1a1c1b] pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1c1b] via-[#2a2c2b] to-[#1a1c1b]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6">
              PRACTICE
              <span className="block text-[#d9fb06]">AREAS</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
              Comprehensive legal services across multiple practice areas, tailored to meet your unique needs.
            </p>
          </div>
        </div>
      </section>

      {/* Practice Areas Grid */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {practiceAreas.map((area) => {
              const IconComponent = iconMap[area.icon] || Briefcase;
              return (
                <Card key={area.id} className="bg-[#302f2c] border-[#3f4816] p-8 hover:bg-[#3f4816] transition-all duration-300 group">
                  <IconComponent className="w-12 h-12 text-[#d9fb06] mb-6 group-hover:scale-110 transition-transform duration-300" />
                  <h3 className="text-2xl font-bold text-white mb-4">{area.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{area.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-[#302f2c]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">ADDITIONAL SERVICES</h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Supporting services to complement our core practice areas
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center p-6">
              <Building className="w-10 h-10 text-[#d9fb06] mx-auto mb-4" />
              <h3 className="text-white font-bold mb-2">Legal Consultation</h3>
              <p className="text-gray-400 text-sm">Expert advice on legal matters</p>
            </div>
            <div className="text-center p-6">
              <Award className="w-10 h-10 text-[#d9fb06] mx-auto mb-4" />
              <h3 className="text-white font-bold mb-2">Document Review</h3>
              <p className="text-gray-400 text-sm">Thorough contract analysis</p>
            </div>
            <div className="text-center p-6">
              <Gavel className="w-10 h-10 text-[#d9fb06] mx-auto mb-4" />
              <h3 className="text-white font-bold mb-2">Court Representation</h3>
              <p className="text-gray-400 text-sm">Skilled litigation advocacy</p>
            </div>
            <div className="text-center p-6">
              <File className="w-10 h-10 text-[#d9fb06] mx-auto mb-4" />
              <h3 className="text-white font-bold mb-2">Legal Documentation</h3>
              <p className="text-gray-400 text-sm">Drafting and filing services</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="container mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            NEED LEGAL ASSISTANCE?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Contact us today to discuss your legal needs and find out how we can help.
          </p>
          <a href="/contact">
            <button className="bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#d9fb06]/90 rounded-full px-12 py-6 text-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105">
              Get In Touch
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default PracticeAreas;
